import { createFileRoute } from '@tanstack/react-router';
import { CompetitorsPage } from '@/pages/CompetitorsPage';

export const Route = createFileRoute('/_authed/competitors')({
  component: CompetitorsPage,
});
